module.exports = __webpack_public_path__ + "static/media/to_create_liveroom2.cf30f0e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/to_create_liveroom2.png
// module id = 585
// module chunks = 6